import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";
import { imageWithTextStyle } from "./imageWithTextStyle";

const ImageWithText = (props) => {
  let  labelText =  useRef(null);
  useEffect(() => {
    if(labelText?.current?.scrollHeight !== null) {
      while (labelText?.current?.scrollHeight > labelText?.current?.offsetHeight) {
        labelText.current.innerText = labelText.current.innerText.replace(/\W*\s(\S)*$/, '...');
      }
    }
  },[labelText]);

  return (
    <div className="text-center">
      <div
        style={{
          width: props.width,
          height: props.height,
          backgroundImage: `url(${props.img_path})`,
        }}
        className="mw-100 custom-image-section"
      />
      {props.children ? props.children : (
        <div className={`image-title mt-s`}>
          <label
            ref={labelText}
            className={`title mt-auto ${props.imageLabelStyle}`}
            dangerouslySetInnerHTML={createMarkup(props.text)}
            uniqueName={props.uniqueName}
          />
        </div>
      )}
      {props?.color ? <label className="color-label">{props?.color}</label> : "" }
      <style jsx>{imageWithTextStyle}</style>
    </div>
  );
};

ImageWithText.propTypes = {
  img_path: PropTypes.string.isRequired,
  image: PropTypes.string,
  text: PropTypes.string,
  imageLabelStyle: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.oneOfType([ // TODO: Fix, color prop implemented as string but used as a bool.
    PropTypes.bool,
    PropTypes.string
  ]),
  uniqueName: PropTypes.string,
  children: PropTypes.element
};

export default ImageWithText;
